export enum ProvaFase {
  FASE1 = 'FASE1',
  FASE2 = 'FASE2'
}

export const ProvaFaseLabel: Record<ProvaFase, string> = {
  [ProvaFase.FASE1]: 'Primeira Fase',
  [ProvaFase.FASE2]: 'Segunda Fase'
}
